<template>
    <div class="pt-3 border-top">
        <div class="page-header">
            <div class="container">
                <div class="row">
                    <div class="col-md-10">
                        <ul class="page-header-breadcrumb">
                            <li>
                                <Link href="/">Home</Link>
                            </li>
                            <li>{{ currentPath }}</li>
                        </ul>
                        <h1>{{ currentPath }}</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Link} from "@inertiajs/vue3";

export default {
    components : {
        Link,
    },
    props      : {
        currentPath : String,
    },
};
</script>
